import './Map.scss';

class Map {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['Map'] = Map;
export default Map;
